import React, {useState} from 'react'
import Renditions from "./renditions";
import ArticleIcons from "./article_icons";
import ArticleSupertitle from "./article_supertitle"

const ArticleTeaser = props => {
    const rand_id = getRandomInt(999999)
    const renditions = Renditions('renditions1')
    function getRandomInt(max) {
        return Math.floor(Math.random() * Math.floor(max))
    }
    return (
        <div>
            <Renditions teaser_renditions='renditions1' article={props.article} rand_id={rand_id} />
            <div className="article_teaser__horizontal_switchable">
                <div className="article_teaser___vertical_box1">
                    <a className={'article_teaser__article article_teaser__article--' + rand_id + '   article_icons_holder bottom light_icons'}
                       href={props.article.url}>
                        <div className={'article_teaser__article-image article_teaser__article-image--' + rand_id}>
                            &nbsp;
                        </div>
                        <div className="article_teaser__article_supertitle supertitle_with_background">
                            <ArticleSupertitle article={props.article} />
                        </div>
                        <ArticleIcons article={props.article} />
                    </a>
                </div>
                <div className="article_teaser___vertical_box2">
                    <a className="article_teaser__title_link" href={props.article.url}>
                        <h3 className="article_teaser__title">
                            <span className="article_teaser__title_text" dangerouslySetInnerHTML={{ __html: `${props.article.title}&nbsp;` }}></span>
                            {props.hassubtitle &&
                            <span className="article_teaser__subtitle_text" dangerouslySetInnerHTML={{ __html: props.article.subtitle }}></span>
                            }
                        </h3>
                    </a>
                    <div className="clear"></div>
                </div>
            </div>
        </div>
    );
}

export default ArticleTeaser;